<template>
    <div>
      <Header/>
      <div class="not_found">
      <h1>Not found</h1>
      </div>
    </div>
</template>

<script>
  import Header from './Header';
  export default {
    name: 'NotFound',
    components: { Header }
  };
</script>

<style scoped lang="scss">
.not_found {
  display: flex;
  margin-top: 300px;
  justify-content: center;
  h1 {
    color: #8c939d;
  }
}
</style>
